import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { THEME } from '../../../common/consts/theme';
import { VideoType } from './interfaces';

export const Video = styled.video<VideoType>`
  border-radius: 1rem;
  width: 100%;
  height: auto;
  display: none;

  ${({ isFullscreen }) =>
    isFullscreen &&
    css`
      display: block;
      height: 100%;
      cursor: default;
    `};
`;

export const VideoContainer = styled.div<VideoType>`
  display: none;
  position: relative;
  border-radius: 1rem;
  flex: 0 0 100%;
  cursor: pointer;
  z-index: 0;

  > * {
    border-radius: 1rem;
  }

  ${({ isFullscreen }) =>
    isFullscreen &&
    css`
      position: fixed;
      align-items: center;
      justify-content: center;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      border-radius: 0;
      background-color: ${THEME.colors.core_black};
      display: flex;
      cursor: default;

      > * {
        border-radius: 0;
      }
    `};
`;

export const VideoCloseButton = styled.div`
  top: 60px;
  right: 40px;
  position: fixed;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
  border-radius: 0.0625rem;

  &:before {
    transform: rotate(-45deg);
  }

  &:after {
    transform: rotate(45deg);
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    height: 3px;
    width: 100%;
    top: 50%;
    left: 0;
    background-color: ${({ theme }) => theme.colors.core_white};
    border-radius: 0.0625rem;
    transition: background-color 200ms ease-in-out;
    box-shadow: 0 0 4px 0.0625rem #1700594a;
  }

  &:hover {
    -webkit-background-clip: text;
    &:before,
    &:after {
      height: 3px;
      background: linear-gradient(
        88.48deg,
        #0f4ed7 0%,
        #684b9f 59.57%,
        #d2485c 98.61%
      );
    }
  }
`;
